import { HttpResponse } from '@angular/common/http'

export function saveBlobResponse(
  resp: HttpResponse<Blob>,
  preferredName?: string,
) {
  const blob = resp.body!
  let filename = ''

  if (preferredName) {
    filename = preferredName
  } else {
    const cd =
      resp.headers.get('Content-Disposition') ||
      resp.headers.get('content-disposition') ||
      ''

    const matchStar = /filename\*\s*=\s*UTF-8''([^;]+)/i.exec(cd)
    const matchPlain = /filename\s*=\s*"?([^";]+)"?/i.exec(cd)

    if (matchStar) {
      filename = decodeURIComponent(matchStar[1])
    } else if (matchPlain) {
      filename = matchPlain[1]
    }
  }

  const genericNames = [
    'download',
    'download-pdf',
    'le document',
    'document',
    'file',
  ]
  const isGeneric = !filename || genericNames.includes(filename.toLowerCase())

  if (isGeneric && resp.url) {
    try {
      const url = new URL(resp.url)
      const lastSegment = url.pathname.split('/').pop()
      if (lastSegment && lastSegment.includes('.')) {
        filename = lastSegment
      }
    } catch {
      // ignore
    }
  }

  if (!filename) {
    filename = 'download'
  }

  if (filename.includes('/') || filename.includes('\\')) {
    filename = filename.split(/[/\\]/).pop() || 'download'
  }

  if (!filename.includes('.')) {
    const contentType = resp.headers.get('Content-Type') || ''
    const exts: Record<string, string> = {
      'image/png': '.png',
      'image/jpeg': '.jpg',
      'application/pdf': '.pdf',
      'video/mp4': '.mp4',
      'audio/mpeg': '.mp3',
      'audio/mp3': '.mp3',
    }
    const match = Object.keys(exts).find((type) => contentType.includes(type))
    if (match) filename += exts[match]
  }

  filename = filename
    .replace(/\s*-\s*/g, '_')
    .replace(/\s+/g, '_')
    .replace(/_+/g, '_')
    .trim()

  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  document.body.appendChild(a)
  a.click()
  a.remove()
  URL.revokeObjectURL(url)
}
